import type { Storyboard as ApiStoryboard } from "@/api/generated/model";
import { listStoryboards } from "@/api/generated/storyboards/storyboards";
import { listPreviewStoryboards } from "@/api/generated/preview/preview";
import type { Storyboard } from "@/types/storyboard";

// The spec describes a storyboard as content type, sub type and a free-form
// payload; the renderers key on the hand-written union in types/storyboard.ts.
// This is the one place the two meet.
const asStoryboards = (storyboards: ApiStoryboard[]) =>
  storyboards as unknown as Storyboard[];

/** The storyboards of a subchapter, in the learner's enrolled course. */
export const listSubChapterStoryboards = async (
  subChapterId: string
): Promise<Storyboard[]> =>
  asStoryboards(await listStoryboards({ sub_chapter_id: subChapterId }));

/** The storyboards of a subchapter in the admin preview of a course. */
export const listPreviewSubChapterStoryboards = async (
  subChapterId: string
): Promise<Storyboard[]> =>
  asStoryboards(await listPreviewStoryboards({ sub_chapter_id: subChapterId }));
